import React from "react";

export function RichText({ html, className = "" }) {
  if (!html) return null;
  return <div className={`prose-tech ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

export function SectionHeading({ eyebrow, title, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-2xl" : ""} ${className}`}>
      {eyebrow ? <div className="eyebrow mb-3">{eyebrow}</div> : null}
      {title ? (
        <h2 className="h-display text-fg text-[clamp(2rem,4vw+0.5rem,3.25rem)]">{title}</h2>
      ) : null}
      <div className={`mt-5 h-px w-16 bg-cyan ${align === "center" ? "mx-auto" : ""}`} />
    </div>
  );
}
